import { Component } from '@angular/core';

@Component({
    selector: 'app-message-box',
    templateUrl: './message-box.component.html',
    standalone: false
})
export class MessageBoxComponent  {

  public openMessageBox: boolean = false;

  constructor() { }

  

  toggleMessageBox() {
    this.openMessageBox = !this.openMessageBox;
  }

}
